import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllSectors() {
  return useMutation({
    mutationFn: ({ page, limit, filter, search }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit)
      });

      if (filter) {
        params.append("filter", filter);
      }

      if (search) {
        params.append("search", search);
      }

      return apiClient({
        url: `admin/sectors/all?${params.toString()}`,
        method: "GET"
      });
    }
  });
}

export function useSectorCreate() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({ url: "admin/sector/create", method: "POST", data: payload })
  });
}
export function useSectorUpdate() {
  return useMutation({
    mutationFn: ({ slug, ...data }) =>
      apiClient({ url: "admin/sector/update/" + slug, method: "PATCH", data })
  });
}

export function useRoleCreate() {
  return useMutation({
    mutationFn: (data) => apiClient({ url: "admin/roles/create", method: "POST", data: data })
  });
}

export function useRoleUpdate() {
  return useMutation({
    mutationFn: ({ slug, ...patchBody }) =>
      apiClient({
        url: "admin/roles/update/" + slug,
        method: "PATCH",
        data: patchBody
      })
  });
}

export function useGetAllSectorsNotPaginated(options) {
  return useQuery({
    queryKey: ["sectorsNotPaginated"],
    queryFn: () => {
      return apiClient({
        url: `sectors/all`,
        method: "GET"
      });
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...options
  });
}
